import {
  HIDE_SUCCESS_MODAL,
  SHOW_SUCCESS_MODAL,
} from '@/store/mutation-types';

export default {
  namespaced: true,
  state: {
    isSuccessModalVisible: false,
    message: '',
  },
  mutations: {
    [HIDE_SUCCESS_MODAL](state) {
      state.isSuccessModalVisible = false;
      state.message = '';
    },
    [SHOW_SUCCESS_MODAL](state, newMessage) {
      state.isSuccessModalVisible = true;
      state.message = newMessage;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/success.js